import { refreshAccessToken } from "./apiClient";
import { API_URL } from "./constant";

// get notifiaction settings data
export async function attemptGetSettingsData(token) {
    
    const response = await fetch(`${API_URL}/alert_data/`,{
        method:"GET",
        headers:{
            'Authorization': `Bearer ${token}`,
        }
    })

    const responseData = await response.json();

    if(!response.ok){
        const err = new Error("Failed to fetch the alert settings data");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// main function to get transaction history
export async function getAlertSettings(token) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try{
        return await attemptGetSettingsData(accessToken);
    }catch(error){
        if (error.status === 401){
            try{
                const newAccessToken = await refreshAccessToken();
                return await attemptGetSettingsData(newAccessToken);
            }catch(refreshError){
                console.log("Token refresh failed",refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error while getting alert settings data", error?.data || error.message);
        throw error;
    }
}

// get alert data which is on user interaction
export async function attemptGetAlertData(token) {
    
    const response = await fetch(`${API_URL}/alert_settings/`,{
        method:"GET",
        headers:{
            'Authorization': `Bearer ${token}`,
        }
    })

    const responseData = await response.json();

    if(!response.ok){
        const err = new Error("Failed to fetch the alert data");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// main function to get transaction history
export async function getAlertData(token) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try{
        return await attemptGetAlertData(accessToken);
    }catch(error){
        if (error.status === 401){
            try{
                const newAccessToken = await refreshAccessToken();
                return await attemptGetAlertData(newAccessToken);
            }catch(refreshError){
                console.log("Token refresh failed",refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error while getting alert data", error?.data || error.message);
        throw error;
    }
}

// update the user alert settings
export async function attemptUpdateAlertSettings(data,token) {
    
    const response = await fetch(`${API_URL}/alert_settings/`,{
        method:"PATCH",
        headers:{
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body:JSON.stringify(data)
    })

    const responseData = await response.json();

    if(!response.ok){
        const err = new Error("Failed to update the Alert Settings");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// main function to update alert settings
export async function updateAlertSettings(data) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try{
        return await attemptUpdateAlertSettings(data,accessToken);
    }catch(error){
        if (error.status === 401){
            try{
                const newAccessToken = await refreshAccessToken();
                return await attemptUpdateAlertSettings(data,newAccessToken);
            }catch(refreshError){
                console.log("Token refresh failed",refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error while updating alert data", error?.data || error.message);
        throw error;
    }
}
